import React from 'react';
import { isFunction } from 'lodash';
import Popover, { PopoverInfo, PopoverProps } from 'react-tiny-popover';
import { Provider } from 'react-redux';

// Getting around circular references
const createContextStore = () => {
  let store = {};

  return {
    setStore: (passedStore: any) => {
      store = passedStore;
    },
    getStore: () => store,
  };
};

export const ContextStore = createContextStore();

export const ConnectedPopover = (props: PopoverProps) => {
  const { children, content, ...rest } = props;
  const store = ContextStore.getStore();

  return (
    <Popover
      {...rest}
      content={(args: PopoverInfo) => (
        <Provider store={store as any}>
          {isFunction(content) ? content(args) : content}
        </Provider>
      )}
    >
      {children}
    </Popover>
  );
};
